import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";
import { selectSignalRReadyMain } from "~/redux/selectors/appSelectors";

export default function SignalRConnectionIndicator() {
  const { t } = useTranslation();
  const connected = useAppSelector(selectSignalRReadyMain);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        px: 2,
        py: 0.5
      }}
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          bgcolor: connected ? "success.main" : "error.main"
        }}
      />
      <Typography variant="body2" color="text.secondary" noWrap>
        SignalR {connected ? t("connected") : t("disconnected")}
      </Typography>
    </Box>
  );
}
